import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const mineGrammarPointV1DataSchema = z.object({
  done: z.boolean(),
  nextCursor: z.string().nullable(),
  candidatesCreated: z.number().int().min(0),
  clipsCreated: z.number().int().min(0),
});

type MineGrammarPointV1DataType = z.infer<typeof mineGrammarPointV1DataSchema>;

export type IMineGrammarPointV1Response = IAPI<MineGrammarPointV1DataType>;

export const mineGrammarPointV1ResponseSchema: z.ZodSchema<IMineGrammarPointV1Response> =
  createApiResponseSchema(mineGrammarPointV1DataSchema) as z.ZodSchema<IMineGrammarPointV1Response>;
